import React from 'react';
import CourseCard from './CourseCard';
import { ChevronRight } from 'react-icons/fa'; // Import a suitable icon

// --- Placeholder Data & Imports (Define this at the top of your file) ---

const courseHair = 'http://localhost:3000/static/media/pexels-cottonbro-3993447.13e453a247301769f5a7.jpg';
const courseTrichology = 'https://media.istockphoto.com/id/1472304183/photo/dark-spots-freckles-hyperpigmentation-concept-skin-lightening-skin-whitening-fruit-acids-aha.jpg?s=612x612&w=0&k=20&c=g4M7E8zEtFMO9lTq_pmpzC_gxw-2-WPopK0EOC_DLNI=';
const courseMakeup = 'https://images.pexels.com/photos/25315717/pexels-photo-25315717.jpeg';
const courseAesthetics = 'https://images.unsplash.com/photo-1599388102324-4f40f0f2d9e6?auto=format&fit=crop&q=80&w=300';
const courseNutrition = 'https://images.unsplash.com/photo-1550989460-0adf9bb6209a?auto=format&fit=crop&q=80&w=300';

// **IMPORTANT:** Added more courses here for demonstration purposes
const coursesData = [
  {
    category: 'Hair',
    title: 'Professional Hair Styling Masterclass ✂️',
    description: 'A comprehensive course covering advanced cutting, coloring techniques, chemical treatments, and bridal styling.',
    duration: '6 Months',
    imageUrl: courseHair,
    features: [
      'Advanced Cutting Techniques',
      'Global and Creative Coloring',
      'Keratin and Smoothening Treatments',
    ],
  },
  {
    category: 'Advanced',
    title: 'Certified Trichology Expert Course 🩺',
    description: 'Specialized training in scalp and hair health analysis, treatment of common hair disorders, and personalized client consultations.',
    duration: '4 Months',
    imageUrl: courseTrichology,
    features: [
      'Scalp Anatomy & Physiology',
      'Dandruff, Alopecia, & Hair Fall Treatment',
      'Clinical Case Studies',
    ],
  },
  {
    category: 'Makeup',
    title: 'Bridal & Portfolio Makeup Artistry 💅',
    description: 'Learn contemporary bridal looks, editorial makeup, and special effects. Build a high-end professional portfolio.',
    duration: '3 Months',
    imageUrl: courseMakeup,
    features: [
      'Contouring & Highlighting',
      'Bridal & Editorial Looks',
      'Airbrush Makeup Basics',
    ],
  },
  {
    category: 'Advanced',
    title: 'Aesthetic Practitioner Diploma',
    description: 'In-depth training on non-invasive cosmetic procedures and client safety protocols.',
    duration: '5 Months',
    imageUrl: courseAesthetics,
    features: [
      'Microdermabrasion',
      'Laser Hair Removal Theory',
      'Client Safety Protocols',
    ],
  },
  {
    category: 'Nutrition',
    title: 'Certified Nutrition & Wellness',
    description: 'Course focused on diet planning, lifestyle coaching, and supplement analysis for comprehensive wellness.',
    duration: '6 Months',
    imageUrl: courseNutrition,
    features: [
      'Diet Planning',
      'Macro and Micronutrients',
      'Wellness Coaching',
    ],
  },
];
// --- End Data ---

const Courses = () => {
  const [filter, setFilter] = React.useState('All');
  const [visibleCount, setVisibleCount] = React.useState(3); // Start by showing 3 courses
  
  const categories = ['All', ...new Set(coursesData.map(c => c.category))];

  // 1. Filter and determine the courses to display
  const filteredCourses = coursesData.filter(course => 
    filter === 'All' ? true : course.category === filter
  );
  
  const coursesToDisplay = filteredCourses.slice(0, visibleCount);
  const hasMoreCourses = filteredCourses.length > visibleCount;

  // Function to show all courses
  const showAllCourses = () => {
    setVisibleCount(filteredCourses.length);
  };

  return (
    <section id="courses" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header/CTA Section */}
        <div className="text-center mb-16">
          <p className="text-pink-600 font-semibold uppercase tracking-widest text-sm mb-2">Start Your Career</p>
          <h2 className="text-5xl font-extrabold text-gray-900 mb-4">
            Transforming Dreams into Professions
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Explore our meticulously designed, industry-certified courses in Hair, Skin, and Advanced Trichology, built on international standards.
          </p>
        </div>
        
        {/* Category Filter Bar */}
        <div className="flex justify-center flex-wrap gap-3 mb-12">
          {categories.map(cat => (
            <button
              key={cat}
              onClick={() => {
                setFilter(cat);
                setVisibleCount(3); // Reset view when changing categories
              }}
              className={`
                px-5 py-2 rounded-full font-medium text-sm transition-all duration-300
                ${filter === cat 
                  ? 'bg-purple-800 text-white shadow-lg' 
                  : 'bg-white text-gray-700 border border-gray-200 hover:bg-pink-50 hover:border-pink-300'
                }
              `}
            >
              {cat}
            </button>
          ))}
        </div>
        
        {/* Courses Grid Container (Relative for positioning the "More" button) */}
        <div className="relative">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {coursesToDisplay.map((course, index) => (
              <CourseCard 
                key={index}
                title={course.title}
                description={course.description}
                duration={course.duration}
                features={course.features}
                imageUrl={course.imageUrl}
              />
            ))}
          </div>

          {/* 2. Blinking "More Courses" Button */}
          {hasMoreCourses && (
    <button
      onClick={showAllCourses}
      className="
        absolute right-0 top-1/2 transform -translate-y-1/2 
        bg-pink-600 text-white font-bold 
        px-4 py-2 rounded-l-lg shadow-xl 
        transition duration-300 
        hover:bg-pink-700
        
        /* CHANGE: Use the new, softer animation class */
        animate-pulse-soft 
      "
      aria-label="Show all available courses"
    >
      More Courses <span className="ml-1 text-lg">››</span>
    </button>
)}
        </div> {/* End of relative container */}
        
        {/* Footer CTA */}
        <div className="text-center mt-16 p-8 bg-purple-50 rounded-xl">
            <h3 className='text-3xl font-bold text-purple-800 mb-3'>Ready to Begin Your Journey?</h3>
            <p className='text-gray-600 mb-5'>Book a free career counseling session with our experts today!</p>
            <a 
                href="#contact" 
                className="bg-pink-600 text-white font-bold px-8 py-3 rounded-full hover:bg-pink-700 transition duration-300 shadow-md"
            >
                Get Counseling
            </a>
        </div>
        
      </div>
    </section>
  );
};

export default Courses;